export const steps = [
  "Order Placed",
  "Completed by Talent",
  "Received",
  "Shipped",
];

export const stepIndex = ({ shipped, received, signed }) =>
  shipped ? 3 : received ? 2 : signed ? 1 : 0;

export const statusText = (status) => {
  const idx = stepIndex(status);
  return steps[idx];
};

export const shipmentStatus = (shipment, mapper = statusText) => {
  return mapper(
    shipment.items.reduce(
      (result, item) => {
        result.shipped &&= item.shipped;
        result.received &&= item.received;
        result.signed &&= item.signed;
        return result;
      },
      { shipped: true, received: true, signed: true },
    ),
  );
};

export const orderStatus = (order, mapper = statusText) => {
  return mapper(
    order.shipments.reduce(
      (result, shipment) => {
        const status = shipmentStatus(shipment, (x) => x);
        result.shipped &&= status.shipped;
        result.received &&= status.received;
        result.signed &&= status.signed;
        return result;
      },
      { shipped: true, received: true, signed: true },
    ),
  );
};
